import { translations } from "../translations";

const LanguageModal = ({ isOpen, onClose, onSelect, currentLang }) => {
  if (!isOpen) return null;

  const t = translations[currentLang]?.languageModal || translations.fr.languageModal;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-2xl font-bold text-center mb-6">{t.title}</h2>
        <div className="grid grid-cols-3 gap-4">
          <button
            onClick={() => onSelect('fr')}
            className={`flex flex-col items-center p-4 rounded-xl border-2 transition-all hover:border-yellow-500 hover:bg-yellow-50 ${
              currentLang === 'fr' ? 'border-yellow-500 bg-yellow-50' : 'border-gray-200'
            }`}
            data-testid="language-fr-button"
          >
            <span className="text-4xl mb-2">🇫🇷</span>
            <span className="text-sm font-medium">{t.french}</span>
          </button>
          <button
            onClick={() => onSelect('nl')}
            className={`flex flex-col items-center p-4 rounded-xl border-2 transition-all hover:border-yellow-500 hover:bg-yellow-50 ${
              currentLang === 'nl' ? 'border-yellow-500 bg-yellow-50' : 'border-gray-200'
            }`}
            data-testid="language-nl-button"
          >
            <span className="text-4xl mb-2">🇳🇱</span>
            <span className="text-sm font-medium">{t.dutch}</span>
          </button>
          <button
            onClick={() => onSelect('en')}
            className={`flex flex-col items-center p-4 rounded-xl border-2 transition-all hover:border-yellow-500 hover:bg-yellow-50 ${
              currentLang === 'en' ? 'border-yellow-500 bg-yellow-50' : 'border-gray-200'
            }`}
            data-testid="language-en-button"
          >
            <span className="text-4xl mb-2">🇬🇧</span>
            <span className="text-sm font-medium">{t.english}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;